// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__1ltxZ","options":"AnswerScale_options__3Balm","selected":"AnswerScale_selected__9SMFL"};